import React from 'react';
import { useTranslation } from 'react-i18next';

const FormulaLoading = () => {
    const { t } = useTranslation();

    return (
        <div className="formula-loading">
            <div className="formula-loading__content">

                {/* Эффектный CSS Атом */}
                <div className="atom-spinner">
                    <div className="atom-spinner__orbit orbit-1"></div>
                    <div className="atom-spinner__orbit orbit-2"></div>
                    <div className="atom-spinner__orbit orbit-3"></div>
                </div>

                <p className="formula-loading__text">
                    {t('translate.affirm_loading') || 'Загрузка...'}
                </p>

            </div>
        </div>
    );
};

export default FormulaLoading;